import { Injectable, OnInit } from '@angular/core';
import { Screening } from '../Models/Screening';
import { DynamicQuestion, FlowOrder } from '../Models/DynamicQuestion';
import { Verbiage, DisplayLanguage } from '../Models/DisplayLanguage';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../../app.config';

@Injectable()
export class DynamicQuestionService implements OnInit {
  screening : Screening;
  order : number = 0;
  questions : DynamicQuestion[] = [];
  private NonFlowVerbiage : Verbiage[];
  public flow : FlowOrder[] = [];
  language : DisplayLanguage = DisplayLanguage.ENGLISH;
  constructor(public http : HttpClient, private config : Configuration) 
  {
    this.NonFlowVerbiage = [
      { Language: DisplayLanguage.ENGLISH, Verbiage: "We participate in the federal government's Work Opportunity Tax Credit program. Your responses to the following questions are used to determine tax credit eligibility.", Component : 'Disclaimer' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'This information is kept in strict confidence and will not negatively impact any hiring process.', Component : 'Disclaimer' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Thank you for your participation.', Component : 'Disclaimer' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Participamos en el programa de Crédito Tributario de Oportunidad Laboral del gobierno federal. Sus respuestas a las siguientes preguntas se utilizan para determinar la elegibilidad del crédito tributario.', Component : 'Disclaimer' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Esta información se mantiene en estricta confidencialidad y no tendrá un impacto negativo en el proceso de contratación.', Component : 'Disclaimer' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Gracias por su participación.', Component : 'Disclaimer' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Dear Applicant', Component: 'Header' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Applicant Survey', Component: 'Header' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Thank you for completing this survey!', Component: 'Header' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Querido solicitantee', Component: 'Header' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Encuesta del solicitante', Component: 'Header' },
      { Language: DisplayLanguage.SPANISH, Verbiage: '¡Gracias por completar esta encuesta!', Component: 'Header' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'I have reviewed the online copy of form 8850 and certify that all information provided by me is true, complete, and correct.', Component: 'Esign' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Under penalties of the law for perjury, I declare that I submitted this information to the employer on or before being offered a job with the employer.', Component: 'Esign' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Using E-signing below, please type your name as you would legally sign into the space provided and select the accept button.', Component: 'Esign' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Your Signature Here', Component: 'Esign' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Accept and send copy to e-mail', Component: 'Esign' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'He revisado la copia en línea del formulario 8850 y certifico que toda la información proporcionada por mí es verdadera, completa y correcta.', Component: 'Esign' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Bajo las penalidades de la ley por perjurio, declaro que presenté esta información al empleador en o antes de que se le ofrezca un trabajo con el empleador.', Component: 'Esign' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Usando la firma electrónica a continuación, ingrese su nombre como lo haría legalmente en el espacio provisto y seleccione el botón Aceptar.', Component: 'Esign' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Tu firma aquí', Component: 'Esign' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Aceptar y enviar copia <br />a un correo electrónico', Component: 'Esign' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Employee Information', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'First Name', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Last Name', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Email', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Phone', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'SSN', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'DOB', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Address', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Información del empleado:', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Nombre Primero', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Apellido', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Email', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Teléfono', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Número de seguridad social', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Fecha de nacimiento', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Dirección', Component: 'EmployeeInfo' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Next', Component: 'Buttons' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Back', Component: 'Buttons' },
      { Language: DisplayLanguage.ENGLISH, Verbiage: 'Please complete all fields before continuing.', Component: 'Buttons' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Continuar', Component: 'Buttons' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Regresa', Component: 'Buttons' },
      { Language: DisplayLanguage.SPANISH, Verbiage: 'Por favor complete todos los campos antes de la continuación', Component: 'Buttons' },
    ];
  }
  
  ngOnInit(): void {
    
  }


  SelectVerbiage(comp : string) : Verbiage[] {
   return this.NonFlowVerbiage.filter((v) => {
     return v.Language == this.language && v.Component == comp;
   })
  }

  FetchPreviewDocument(type : string) {
    window.open(this.config.APIBaseUrl + `/api/Screening/doc/integration/${type}/${this.screening.integrationProfile.employeeId}`);
  }

  SaveScreeningToDatabase() {
    return this.http.post<Screening>(this.config.APIBaseUrl +'/api/Screening/integration/save', this.screening);
  }  

}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/services/dynamic-question.service.ts